/* eslint-disable */
import React, { Fragment } from 'react'
import Logo from '../../components/Logo'

export default ({children}) => (
	<div className="container">
		{children}
		{/* <footer>
			<a href="https://unified.com/privacy-policy">Privacy Policy</a><span>| ©2018 Unified Enterprise Corp.</span>
		</footer> */}
	</div>
)


// WEBPACK FOOTER //
// ./src/containers/Results/wrapper.js